import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  user: null,
  loading: false,
  error: null,
};

const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    testStart: state => {
      state.loading = true;
      state.error = null;
    },
    testSuccess: (state, action) => {
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    testFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default testSlice.reducer;
export const {testStart, testSuccess, testFailure} = testSlice.actions;
